import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, formDataPut, patch, post, put } from "helpers/api_helper"
import {
  ADD_BANNER,
  ADD_SLIDE,
  DELETE_BANNER,
  DELETE_SLIDE,
  GET_ALL_BANNERS_LIST,
  GET_BANNER_DETAILS,
  GET_SLIDE_DETAILS,
  UPDATE_BANNER,
  UPDATE_BANNER_STATUS,
  UPDATE_SLIDE,
  UPDATE_SLIDE_STATUS,
} from "helpers/url_helper"

//BANNERS
export const getAllBanners = createAsyncThunk(
  GET_ALL_BANNERS_LIST,
  async payload => {
    const response = await post(GET_ALL_BANNERS_LIST, payload)
    return response
  }
)

export const addBanner = createAsyncThunk(ADD_BANNER, async payload => {
  const response = await post(ADD_BANNER, payload)
  return response
})

export const deleteBanner = createAsyncThunk(DELETE_BANNER, async payload => {
  const response = await del(DELETE_BANNER, payload)
  return response
})

export const getBannerDetails = createAsyncThunk(
  GET_BANNER_DETAILS,
  async payload => {
    const response = await post(GET_BANNER_DETAILS, payload)
    return response
  }
)

export const updateBanner = createAsyncThunk(UPDATE_BANNER, async payload => {
  const response = await put(UPDATE_BANNER, payload)
  return response
})

export const updateBannerStatus = createAsyncThunk(
  UPDATE_BANNER_STATUS,
  async payload => {
    const response = await patch(UPDATE_BANNER_STATUS, payload)
    return response
  }
)

// SLIDES
export const getSlideDetails = createAsyncThunk(
  GET_SLIDE_DETAILS,
  async payload => {
    const response = await post(GET_SLIDE_DETAILS, payload)
    return response
  }
)

export const updateSlideStatus = createAsyncThunk(
  UPDATE_SLIDE_STATUS,
  async payload => {
    const req = { id: payload.id, status: payload.status }
    const response = await patch(UPDATE_SLIDE_STATUS, req)
    return response
  }
)

export const deleteSlide = createAsyncThunk(DELETE_SLIDE, async payload => {
  const req = { id: payload.id, status: payload.status }
  const response = await del(DELETE_SLIDE, req)
  return response
})

export const addSlide = createAsyncThunk(ADD_SLIDE, async payload => {
  const response = await formDataPost(ADD_SLIDE, payload)
  return response
})

export const updateSlide = createAsyncThunk(UPDATE_SLIDE, async payload => {
  const response = await formDataPut(UPDATE_SLIDE, payload)
  return response
})
